
/**
 * @fileOverview SubscribeValidate module definition
 * @author a1rqlzz
 * @modified 05/17/2015
 **/

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('kungfu/SubscribeValidate/SubscribeValidate',['require','jquery','validate','lib/Util'],function (require) {
        var $ = require('jquery'),
            subVal = require('validate'),
            util = require('lib/Util');

        require(['domReady!'], function (doc) {
            /*Fires upon DOM Ready to initialize component*/
            $debug('**** Validate Set Up Started **** ', 'mmmSubValidate');
            $('.js-subvalidate').each(function (i,element) {
                $debug('Validate Block #' + (i + 1), 'mmmSubValidate');
                new SubscribeValidate($(element));
            });

        });
        $debug('MMMSubValidate loaded - use ?debug=mmmSubValidate for messages');

       /**
         * This sets up Subscribe Validation.
         *
         * @class ExpandContentView
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var SubscribeValidate = function ($element) {

            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             */
            this.$element = $element;

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @name isEnabled
             * @type bool
             */
            this.isEnabled = false;

            this.init(); //initialize component
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {ExpandContentView}
         * @private
         */
        SubscribeValidate.prototype.init = function () {
            this
                .setOptions()
                .createChildren()
                .setupHandlers()
                .enable()
                .build();

            return this;
        };

        SubscribeValidate.prototype.createChildren = function () {
            this.$fieldcontainer = this.$element.find($('.MMM--subscribeList'));
            this.$fancyDropdown = this.$fieldcontainer.find($('.js-fancyDropDown'));
            this.$fancyDropdownList = this.$fieldcontainer.find($('.js-fancyDropDiv'));
            this.$hiddenfields =[];


            return this;
        };

        SubscribeValidate.prototype.enable = function () {
            var self=this;

            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;

            //enabling events for the select lists and email link
             var selectopts = this.$fancyDropdown, self = this;

            selectopts.on('change', function (event) {
                event.preventDefault();
                self.onChangeHandler($(this));
            });

            return this;
        };

        /**
         * This sets the options via data-options in the html markup. If
         * the options aren't set it goes to the defaults.
         *
         * @method setOptions
         * @returns {ExpandContentView}
         * @private
         */
        SubscribeValidate.prototype.setOptions = function () {
            var options = this.$element.data().options;
            var defaults = {
                enabled : true,
                debug : false,
                submitHandler : null
            };
            this.settings = $.extend({}, defaults, options);
            $debug('     Block Options ', 'mmmSubValidate');
            $debug('          HTML data-options Settings: ' + $printObj(options),'mmmSubValidate');
            $debug('          Default Settings: ' + $printObj(defaults),'mmmSubValidate');
            $debug('          Combined Settings: ' + $printObj(this.settings),'mmmSubValidate');
			$debug('          Rules Settings: ' + $printObj(this.settings.rules),'mmmSubValidate');
            return this;
        };

        SubscribeValidate.prototype.setupHandlers = function () {
            this.onChangeHandler = this.onChange.bind(this);

            return this;
        };

        /**
         * Builds the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {ExpandContentView}
         * @public
         */
        SubscribeValidate.prototype.build = function () {
            if (!this.isEnabled) {
               return this;
            }
            this.isEnabled = true;

            var self = this;
			
			var enabled = self.settings.enabled;
			
			function errorPlacement(error, element){
				var errorDD;

                $debug('*** ' + element.attr('name') + ' has error of ' + error.text() ,'mmmSubValidate');
				if (element.attr('type') === 'radio') {
					errorDD = $('<div class="MMM--gapTop MMM--errorMessage error"></div>').insertAfter($('input:radio[name="'+ element.attr('name')+'"]:last').next());
				}
				else if (element.attr('type') === 'checkbox') {
					errorDD = $('<div class="MMM--gapTop MMM--errorMessage error"></div>').insertAfter($('input:checkbox[name="'+ element.attr('name')+'"]:last').next());
					//$('.MMM--subscribeInfo').css('padding-top', 50);
				}
				else {
					if (element.hasClass('subValCheck') === true){

						errorDD = $('<div class="MMM--gapTop MMM--errorMessage error"></div>').insertAfter(element.next());
					} else{
						errorDD = $('<div class="MMM--gapTop MMM--errorMessage error"></div>').insertAfter(element);
					}
                    //$msg('meaq' + $element);
                    if (element.parent().hasClass('js-fancyDropDiv') ) {
                    $debug('in js-fancyDropDiv!!!!!!!!' ,'mmmSubValidate');
                    errorDD = $('<div class="MMM--gapTop MMM--errorMessage error"></div>').insertAfter( $(element).parent());
                    element.parent().css('margin-top', -5);
                }

				}

                //error.prepend('* ');
				error.appendTo(errorDD);
				return true;
			}
			
            var eleId = '#' + self.$element.attr('id');
			
			$(eleId).validate({
				rules :  this.settings.rules,

                highlight: function(element, errorClass, validClass) {
                    if ($(element).hasClass('js-fancyDropDown')) {
                        $(element).parent().find($('.MMM--fancyDropAnchor')).css({'border':'1px #ff0000 solid', 'color':'#ff0000'});
                    }
                    $(element).addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function(element, errorClass, validClass) {
                    $debug('in un highlight elem ' + $(element).attr('class') + ' msg ' + errorClass ,'mmmSubValidate');
                    $(element).removeClass(errorClass).addClass(validClass);
                    if ($(element).attr('name').indexOf('subject') !== -1) {
                        $(element).parent().find($('.MMM--fancyDropAnchor')).css({'border': 'none', 'color' :'#000000'});
                    }
                },
                errorPlacement: errorPlacement,

				submitHandler: function(form){
                    $debug('submitHandler = ' + typeof self.settings.submitHandler, 'mmmSubValidate');

                    if (typeof self.settings.submitHandler === 'string'){
                        $debug('custom submit value present -- firing ' + self.settings.submitHandler , 'mmmSubValidate');
                        window[self.settings.submitHandler](form);
                        // $msg('Self.settings.submitHandler = '+ self.settings.submitHandler);
                    }
                    else {
                        $debug('no custom submit present -- submitting form', 'mmmSubValidate');
                        form.submit();
                    }
				},

                debug : self.settings.debug
			});
            return this;
        };

        SubscribeValidate.prototype.onChange = function (target) {
            // change event for Subject fancy select box
            var self = this;

            this.$hiddenfields = [];

            this.$fancyDropdown.removeClass('error');
            this.$fancyDropdown.parent().parent().find($('.error')).remove();
            this.$fancyDropdownList.removeAttr( 'style' );
            $(target).parent().find($('.MMM--fancyDropAnchor')).css({'border':'1px solid #e5e4e4', 'color' :'#000000'});
            $(target).parent().find($('.error')).remove();

            // populating select list with the selected attribute and the Subjectline variable with the actual text value of the subject drop down
            $('#'+ $(target).attr('id') +' option').each(function(i){
                if ($(this).val() === $(target).val()) {
                    $('#'+ $(target).attr('id') +' option[value="'+$(this).val()+'"]' ).attr('selected', 'selected');
                    self.SubjectLine = $('#'+ $(target).attr('id') +' option[value="'+$(this).val()+'"]' ).text();
                }
                else {
                    $('#'+ $(target).attr('id') +' option[value="'+$(this).val()+'"]' ).attr('selected', false);
                }
            });

            this.clearErrors();
            return false;
        };

        SubscribeValidate.prototype.clearErrors = function (target) {

            this.$fancyDropdown.each(function(elem) {
                $msg('fancyDropdown ' + $(this).attr('class'));

                if ($(this).parent().parent().parent().next('.error')) {
                    $(this).parent().parent().parent().next('.error').remove();
                }
            });
            return false;
        };
    });

}(MMMRequire));